(function () {
  function bindNavigation(swiper, root) {
    var desktopPrev = root.querySelector('.sa-as-seen-on-nav--desktop.sa-as-seen-on-nav--prev');
    var desktopNext = root.querySelector('.sa-as-seen-on-nav--desktop.sa-as-seen-on-nav--next');
    var mobilePrev = root.querySelector('.sa-as-seen-on-nav--mobile.sa-as-seen-on-nav--prev');
    var mobileNext = root.querySelector('.sa-as-seen-on-nav--mobile.sa-as-seen-on-nav--next');

    var updateEdgeState = function () {
      var realIndex = typeof swiper.realIndex === 'number' ? swiper.realIndex : swiper.activeIndex;
      var lastIndex = swiper.slides.length - 1;
      var atStart = realIndex === 0;
      var atEnd = realIndex === lastIndex;

      [desktopPrev, mobilePrev].forEach(function (button) {
        if (!button) return;
        button.classList.toggle('sa-as-seen-on-nav--edge', atStart);
        button.disabled = atStart;
      });

      [desktopNext, mobileNext].forEach(function (button) {
        if (!button) return;
        button.classList.toggle('sa-as-seen-on-nav--edge', atEnd);
        button.disabled = atEnd;
      });
    };

    [desktopPrev, mobilePrev].forEach(function (button) {
      if (!button) return;
      button.addEventListener('click', function () {
        swiper.slidePrev();
      });
    });

    [desktopNext, mobileNext].forEach(function (button) {
      if (!button) return;
      button.addEventListener('click', function () {
        swiper.slideNext();
      });
    });

    swiper.on('init', updateEdgeState);
    swiper.on('slideChange', updateEdgeState);
    updateEdgeState();
  }

  function initSection(root) {
    if (!root || root.dataset.asSeenOnReady === 'true') return true;
    if (typeof window.Swiper === 'undefined') return false;

    var el = root.querySelector('[data-sa-as-seen-on-swiper]');
    if (!el) return true;

    if (el.swiper) {
      el.swiper.destroy(true, true);
    }

    var desktopPrev = root.querySelector('.sa-as-seen-on-nav--desktop.sa-as-seen-on-nav--prev');
    var mobilePrev = root.querySelector('.sa-as-seen-on-nav--mobile.sa-as-seen-on-nav--prev');
    var hasNavigation = Boolean(desktopPrev || mobilePrev);

    var swiper = new window.Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 300,
      watchOverflow: true,
      observer: true,
      observeParents: true,
    });

    if (hasNavigation) {
      bindNavigation(swiper, root);
    }

    root.dataset.asSeenOnReady = 'true';
    return true;
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('.sa-as-seen-on');
    var pending = false;

    roots.forEach(function (root) {
      if (!initSection(root)) {
        pending = true;
      }
    });

    return !pending;
  }

  function boot(retries) {
    if (initAll()) return;

    if (retries > 0) {
      window.setTimeout(function () {
        boot(retries - 1);
      }, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(50);
    });
  } else {
    boot(50);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.sa-as-seen-on');
    if (root) {
      delete root.dataset.asSeenOnReady;
      boot(50);
    }
  });
})();
